<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="indigo darken-2" dark dense>
        <v-icon left>assignment_ind</v-icon>
        <v-toolbar-title>Zimmet Yönetimi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Ara (kullanıcı / ürün / seri)"
          single-line
          hide-details
          clearable
          class="mr-2"
          style="max-width: 320px"
        ></v-text-field>
        <v-btn icon :loading="loading" @click="loadAll">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn flat class="inv-btn ma-0 ml-1" @click="openAssign">
          <v-icon left>assignment_ind</v-icon>
          Zimmetle
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-layout wrap class="inv-stats">
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--purple">
              <div class="inv-stat-label">Zimmetli Kişi</div>
              <div class="inv-stat-value">{{ groupedLines.length }}</div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--teal">
              <div class="inv-stat-label">Toplam Adet</div>
              <div class="inv-stat-value">{{ totalQuantity }}</div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--green">
              <div class="inv-stat-label">Toplam Has</div>
              <div class="inv-stat-value">{{ totalHas.toFixed(4) }} <span class="inv-stat-unit">gr</span></div>
            </div>
          </v-flex>
          <v-flex xs6 sm3>
            <div class="inv-stat inv-stat--grey">
              <div class="inv-stat-label">Takı (Seri)</div>
              <div class="inv-stat-value">{{ jewelryCount }}</div>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="!groupedLines.length && !loading" class="inv-empty">
          <v-icon large color="grey lighten-1">assignment_ind</v-icon>
          <div>Henüz zimmetli ürün yok.</div>
        </div>
        <div v-else>
          <div
            class="inv-card inv-card--clickable"
            v-for="g in groupedLines"
            :key="g.userId"
            @click="openDetail(g)"
          >
            <div class="inv-icon inv-icon--purple">
              <v-icon color="white" small>person</v-icon>
            </div>

            <div class="inv-card-l">
              <div class="inv-head">
                <span class="inv-title">{{ g.name }}</span>
                <span class="inv-chip inv-chip--purple">{{ g.lines.length }} kayıt</span>
                <span v-if="g.userName" class="inv-sub">{{ g.userName }}</span>
              </div>

              <div class="inv-items">
                <span class="inv-item" v-for="(it, idx) in itemChips(g)" :key="idx">{{ it }}</span>
              </div>

              <div class="inv-meta">
                <v-icon x-small color="blue-grey lighten-2">layers</v-icon>
                {{ g.quantity }} adet
                <span class="inv-dot">·</span>
                <v-icon x-small color="blue-grey lighten-2">category</v-icon>
                {{ typeSummary(g) }}
              </div>
            </div>

            <div class="inv-card-r">
              <div class="inv-value">
                <div class="inv-value-num">{{ g.hasGram.toFixed(4) }}</div>
                <div class="inv-value-label">gr has</div>
              </div>
              <v-btn color="indigo darken-2" dark class="inv-btn ma-0 ml-3" @click.stop="openDetail(g)">
                <v-icon small left>list</v-icon>
                Detay
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="detailDialog" max-width="960" scrollable>
      <v-card>
        <v-card-title class="headline indigo darken-2 white--text">
          <v-icon left color="white">person</v-icon>
          {{ detailGroup ? detailGroup.name : '' }}
          <v-spacer></v-spacer>
          <span v-if="detailGroup" class="subheading">{{ detailGroup.hasGram.toFixed(4) }} gr has</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            v-if="detailGroup"
            :headers="detailHeaders"
            :items="detailGroup.lines"
            hide-actions
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td class="px-2">
                <span class="inv-chip" :class="typeChipClass(props.item.inventoryType)">
                  {{ props.item.inventoryTypeName }}
                </span>
              </td>
              <td class="px-2">{{ props.item.productName }}{{ variantSuffix(props.item) }}</td>
              <td class="px-2">{{ props.item.weight }}</td>
              <td class="px-2">{{ props.item.purityLabel }}</td>
              <td class="px-2">{{ props.item.size || '-' }}</td>
              <td class="px-2">{{ props.item.serialNumber || '-' }}</td>
              <td class="px-2 text-xs-right">{{ props.item.quantity }}</td>
              <td class="px-2">
                <v-btn small flat color="red darken-1" class="inv-btn ma-0" @click="openReturn(props.item)">
                  <v-icon small left>undo</v-icon>
                  Geri Al
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <div v-else class="inv-empty">
            <v-icon large color="grey lighten-1">assignment_ind</v-icon>
            <div>Henüz zimmetli ürün yok.</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="detailDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== ZİMMETLE DIALOG ========== -->
    <v-dialog v-model="assignDialog" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline indigo darken-2 white--text">
          <v-icon left color="white">assignment_ind</v-icon>
          Zimmetle
        </v-card-title>
        <v-card-text class="pa-4">
          <v-select
            v-model="assignForm.userId"
            :items="users"
            item-text="label"
            item-value="id"
            label="Kullanıcı"
          ></v-select>

          <v-tabs v-model="assignTab" grow class="mb-2">
            <v-tab>Ziynet / Külçe</v-tab>
            <v-tab>Takı</v-tab>
          </v-tabs>

          <!-- Ziynet/Külçe -->
          <div v-if="assignTab === 0">
            <v-select
              v-model="assignForm.inventoryItemId"
              :items="ziynetKulceItems"
              item-text="label"
              item-value="id"
              label="Ürün (Ziynet/Külçe)"
            ></v-select>
            <div v-if="selectedInventoryItem" class="caption grey--text mb-2">
              Ana envanterde boşta: <strong>{{ availableOf(selectedInventoryItem) }}</strong> adet
              (Toplam {{ selectedInventoryItem.quantity }})
            </div>
            <v-text-field
              v-model.number="assignForm.quantity"
              label="Adet"
              type="number"
              min="1"
            ></v-text-field>
          </div>

          <!-- Takı -->
          <div v-else>
            <v-text-field
              v-model="assignForm.barcode"
              label="Takı Barkodu / Seri No"
              prepend-icon="qr_code_scanner"
              hint="Sertifikadaki barkodu okutun veya yazın"
              persistent-hint
              autofocus
              @keyup.enter="saveAssign"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="assignDialog = false">İptal</v-btn>
          <v-btn color="indigo darken-2" dark class="inv-btn" :loading="assignSaving" @click="saveAssign">Zimmetle</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== GERİ AL DIALOG (ziynet/külçe adet) ========== -->
    <v-dialog v-model="returnDialog" max-width="460" persistent>
      <v-card>
        <v-card-title class="headline red darken-1 white--text">
          <v-icon left color="white">undo</v-icon>
          Ana Envantere Geri Al
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="mb-2">
            <strong>{{ fullName(returnTarget) }}</strong> →
            {{ returnTarget && returnTarget.productName }}{{ variantSuffix(returnTarget) }}
          </div>
          <v-text-field
            v-model.number="returnQuantity"
            label="Geri alınacak adet"
            type="number"
            min="1"
            :max="returnTarget ? returnTarget.quantity : 1"
          ></v-text-field>
          <div class="caption grey--text">
            Kullanıcıda zimmetli: {{ returnTarget ? returnTarget.quantity : 0 }} adet
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="returnDialog = false">İptal</v-btn>
          <v-btn color="red darken-1" dark class="inv-btn" :loading="returnSaving" @click="confirmReturn">Geri Al</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { userService } from "@/_services";

export default {
  data: () => ({
    loading: false,
    lines: [],
    users: [],
    inventoryItems: [],
    search: "",
    headers: [
      { text: "Kullanıcı", value: "userName" },
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Seri No", value: "serialNumber" },
      { text: "Adet", value: "quantity", align: "right" },
      { text: "", value: "actions", sortable: false },
    ],

    detailDialog: false,
    detailUserId: null,

    assignDialog: false,
    assignSaving: false,
    assignTab: 0,
    assignForm: { userId: null, inventoryItemId: null, quantity: 1, barcode: "" },

    returnDialog: false,
    returnSaving: false,
    returnTarget: null,
    returnQuantity: 1,
  }),

  computed: {
    ziynetKulceItems() {
      return this.inventoryItems
        .filter(i => i.inventoryType !== 0) // 0 = Takı
        .map(i => ({
          ...i,
          label: `${i.inventoryTypeName} - ${i.productName}${this.variantSuffix(i)} (${i.weight} gr, ${i.purityLabel}) — boşta ${this.availableOf(i)}`,
        }));
    },
    selectedInventoryItem() {
      return this.inventoryItems.find(i => i.id === this.assignForm.inventoryItemId) || null;
    },
    filteredLines() {
      const q = (this.search || "").toLocaleLowerCase("tr");
      if (!q) return this.lines;
      return this.lines.filter(l =>
        [this.fullName(l), l.userName, l.productName, l.serialNumber, l.inventoryTypeName]
          .filter(Boolean)
          .some(v => v.toLocaleLowerCase("tr").includes(q))
      );
    },
    groupedLines() {
      const map = new Map();
      this.filteredLines.forEach(l => {
        let g = map.get(l.userId);
        if (!g) {
          g = {
            userId: l.userId,
            name: this.fullName(l),
            userName: l.userName,
            lines: [],
            quantity: 0,
            hasGram: 0,
          };
          map.set(l.userId, g);
        }
        g.lines.push(l);
        g.quantity += l.quantity || 0;
        g.hasGram += Number(l.hasGram) || 0;
      });
      return Array.from(map.values()).sort((a, b) => b.hasGram - a.hasGram);
    },
    detailGroup() {
      if (this.detailUserId == null) return null;
      return this.groupedLines.find(g => g.userId === this.detailUserId) || null;
    },
    detailHeaders() {
      return this.headers.filter(h => h.value !== "userName");
    },
    totalQuantity() {
      return this.filteredLines.reduce((s, l) => s + (l.quantity || 0), 0);
    },
    totalHas() {
      return this.filteredLines.reduce((s, l) => s + (Number(l.hasGram) || 0), 0);
    },
    jewelryCount() {
      return this.filteredLines.filter(l => l.inventoryType === 0).length;
    },
  },

  created() {
    this.loadAll();
  },

  methods: {
    fullName(l) {
      if (!l) return "";
      const n = [l.firstName, l.lastName].filter(Boolean).join(" ").trim();
      return n || l.userName || `#${l.userId}`;
    },
    // Ziynet varyantı: Kulp (Kulplu/Kulpsuz) + Tarih (Yeni/Eski). Boşsa boş döner.
    variantSuffix(i) {
      if (!i) return "";
      const parts = [i.kulp, i.dateType].filter(Boolean);
      return parts.length ? ` [${parts.join(" / ")}]` : "";
    },
    typeColor(t) {
      if (t === 0) return "teal";
      if (t === 1) return "amber darken-2";
      return "blue-grey darken-1";
    },
    typeChipClass(t) {
      const c = this.typeColor(t);
      if (c === "teal") return "inv-chip--teal";
      if (c === "amber darken-2") return "inv-chip--wait";
      return "inv-chip--grey";
    },
    itemChips(g) {
      const map = new Map();
      g.lines.forEach(l => {
        const key = `${l.productName || "-"}${this.variantSuffix(l)}`;
        map.set(key, (map.get(key) || 0) + (l.quantity || 0));
      });
      return Array.from(map.entries()).map(([label, qty]) => `${label} ×${qty}`);
    },
    typeSummary(g) {
      const map = new Map();
      g.lines.forEach(l => {
        const key = l.inventoryTypeName || "-";
        map.set(key, (map.get(key) || 0) + (l.quantity || 0));
      });
      return Array.from(map.entries())
        .map(([label, qty]) => `${label} ${qty}`)
        .join(" / ");
    },
    openDetail(g) {
      this.detailUserId = g.userId;
      this.detailDialog = true;
    },
    // Ana envanterde boşta = toplam - (bu üründen tüm kullanıcılara zimmetli)
    availableOf(item) {
      if (!item) return 0;
      const assigned = this.lines
        .filter(l => l.inventoryItemId === item.id)
        .reduce((s, l) => s + (l.quantity || 0), 0);
      return item.quantity - assigned;
    },

    async loadAll() {
      this.loading = true;
      try {
        const [linesRes, itemsRes, usersRes] = await Promise.all([
          this.$store.dispatch("inventory/getAllZimmets"),
          this.$store.dispatch("inventory/getInventoryItems"),
          userService.getAll(),
        ]);
        this.lines = linesRes || [];
        this.inventoryItems = itemsRes || [];
        this.users = (usersRes || []).map(u => ({
          ...u,
          label: [u.firstName, u.lastName].filter(Boolean).join(" ").trim()
            ? `${[u.firstName, u.lastName].filter(Boolean).join(" ")} (${u.username})`
            : u.username,
        }));
      } catch (e) {
        this.notify("Zimmet verileri yüklenemedi: " + this.errMsg(e));
      } finally {
        this.loading = false;
      }
    },

    openAssign() {
      this.assignForm = { userId: null, inventoryItemId: null, quantity: 1, barcode: "" };
      this.assignTab = 0;
      this.assignDialog = true;
    },

    async saveAssign() {
      if (!this.assignForm.userId) {
        this.notify("Lütfen kullanıcı seçin.");
        return;
      }
      let dto;
      if (this.assignTab === 1) {
        const code = (this.assignForm.barcode || "").trim().replace(/\*/g, "-"); // okuyucu "-"yi "*" gönderebilir
        if (!code) { this.notify("Takı barkodu okutun."); return; }
        dto = { userId: this.assignForm.userId, barcode: code };
      } else {
        if (!this.assignForm.inventoryItemId) { this.notify("Ürün seçin."); return; }
        if (!this.assignForm.quantity || this.assignForm.quantity <= 0) { this.notify("Adet 0'dan büyük olmalı."); return; }
        dto = {
          userId: this.assignForm.userId,
          inventoryItemId: this.assignForm.inventoryItemId,
          quantity: this.assignForm.quantity,
        };
      }
      this.assignSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetAssign", dto);
        if (res && res.success === false) { this.notify(res.message); return; }
        // Takı modunda barkod alanını temizleyip açık tut (seri okutmaya devam)
        if (this.assignTab === 1) {
          this.assignForm.barcode = "";
        } else {
          this.assignDialog = false;
        }
        this.notify((res && res.message) || "Zimmetlendi.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.assignSaving = false;
      }
    },

    openReturn(line) {
      this.returnTarget = line;
      // Takı: tek tıkla geri al (seri bazında, adet=1)
      if (line.inventoryType === 0) {
        this.doReturnTaki(line);
        return;
      }
      this.returnQuantity = line.quantity;
      this.returnDialog = true;
    },

    async doReturnTaki(line) {
      this.returnSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetReturn", { barcode: line.serialNumber });
        if (res && res.success === false) { this.notify(res.message); return; }
        this.notify((res && res.message) || "Ana envantere geri alındı.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.returnSaving = false;
      }
    },

    async confirmReturn() {
      if (!this.returnTarget) return;
      if (!this.returnQuantity || this.returnQuantity <= 0) { this.notify("Adet 0'dan büyük olmalı."); return; }
      this.returnSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetReturn", {
          userId: this.returnTarget.userId,
          inventoryItemId: this.returnTarget.inventoryItemId,
          quantity: this.returnQuantity,
        });
        if (res && res.success === false) { this.notify(res.message); return; }
        this.returnDialog = false;
        this.notify((res && res.message) || "Ana envantere geri alındı.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.returnSaving = false;
      }
    },

    errMsg(e) {
      return (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "Bilinmeyen hata";
    },
    notify(msg) {
      this.$store.state.dialog = true;
      this.$store.state.message = msg;
    },
  },
};
</script>
